import React from 'react'
import { useState, useEffect, useLayoutEffect } from 'react';
import { useParams } from 'react-router-dom';
import firebase from 'firebase/compat/app';
import { gsap } from 'gsap';
import "./FullProject.scss"
import { Container } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import GalleryNav from './GalleryNav';
import MeteFooter from './MeteFooter';
import ProjectCarousel from './skeletons/ProjectCarousel';
import { BiLogoBlender } from "react-icons/bi"
import { SiAdobephotoshop } from "react-icons/si"
import { SiAdobeillustrator } from "react-icons/si"
import { CgFigma } from "react-icons/cg"
import { SiAdobepremierepro } from "react-icons/si"
import { IoLogoFirebase } from "react-icons/io5";
import { DiVisualstudio } from "react-icons/di";
import { SiAdobeaftereffects } from "react-icons/si";

import { SiAdobeindesign } from "react-icons/si";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import ReactGA from "react-ga4";
import { FaReact } from "react-icons/fa";

function FullProject() {
    const { id } = useParams(); // Access the id parameter from the URL
    const [images, setImages] = useState([]);
    const [project, setProject] = useState(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [loadingWithImages, setLoadingWithImages] = useState(false);





    useEffect(() => {
        let ctx = gsap.context(() => {
            gsap.to(".App", { duration: .0, css: { visibility: 'visible' } });
        });
        return () => {
            ctx.revert();
        }
    }, []);



    useEffect(() => {
        const fetchProject = async () => {
            setLoadingWithImages(true);
            try {
                const projectRef = firebase.firestore().collection('Portfolio').doc(id);
                const projectDoc = await projectRef.get();
                if (projectDoc.exists) {
                    const projectData = projectDoc.data();
                    setProject(projectData);
                    const imagesRef = projectRef.collection('Images');
                    const imagesSnapshot = await imagesRef.get();
                    const imagesData = imagesSnapshot.docs.map(doc => doc.data());
                    setImages(imagesData);
                } else {
                    console.log('No such document!');
                }
            } catch (error) {
                console.error('Error fetching project data: ', error);
            } finally {
                setLoadingWithImages(false);
            }
        };

        fetchProject();

    }, [id]);

    useEffect(() => {
        if (project && project.Title) {
            const pageTitle = `Full Project Page: ${project.Title}`;
            console.log(pageTitle);
            ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: pageTitle });
        }
    }, [project]);



    const [timer, setTimer] = useState(null);
    const handleImageClick = (index) => {
        if (currentImageIndex < images.length) {
            if (index >= 0) {
                setCurrentImageIndex(index + 1); // Increase index by 1 to match the image index
            } else {
                setCurrentImageIndex(currentImageIndex + 1);
            }
        } else {
            setCurrentImageIndex(currentImageIndex - 1);
        }
        // Clear existing timer and set a new one
        clearTimeout(timer);
        const newTimer = setTimeout(() => {
            setCurrentImageIndex(0);
        }, 10000); // Change 5000 to the number of milliseconds you want to wait before resetting to index 0
        setTimer(newTimer);

    };


    useLayoutEffect(() => {
        window.scrollTo(0, 0); // Scrolls the page to the top on initial render
    }, []); // Empty dependency array ensures it only runs on initial render

    useEffect(() => {
        const handleBeforeUnload = () => {
            window.scrollTo(0, 0); // Scrolls the page to the top when the page is about to be unloaded
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []); // Empty dependency array ensures the effect runs only once


    return (
        <div className="ProjApp">

            <Container className="Project">

                <GalleryNav />

                <div className="cutscene">

                </div>
                {loadingWithImages || !images || !project ? (
                    <Row xs={1} md={4}>
                        <Col className='col-sm'>
                            <ProjectCarousel />
                        </Col>
                    </Row>
                ) : (
                    <div className="folde">
                        <Row>
                            <Col >
                                <h2>Case Study</h2>
                                <h3>{project.Title}</h3>
                                <p>{project.Detail}</p>
                                <p><strong>Client:</strong> {project.Client}</p>
                                <p><strong>Client Background:</strong> {project.Background}</p>
                                <p><strong>Objective:</strong> {project.Objective}</p>
                                <p><strong>Challenges:</strong> {project.Challenges}</p>
                                <p><strong>Solutions:</strong> {project.Solutions}</p>
                                <p><strong>Results:</strong> {project.Results}</p>
                                <strong>Tools Used:</strong>
                                <p >
                                    {project.Tools && project.Tools.split(',').map((tool, index) => {
                                        const trimmedTool = tool.trim();
                                        switch (trimmedTool) {
                                            case 'Blender':
                                                return <BiLogoBlender key={index} className='iconsTools' title="Blender" />;
                                            case 'Illustrator':
                                            case 'Adobe Illustrator':
                                                return <SiAdobeillustrator key={index} className='iconsTools' title="Adobe Illustrator" />;
                                            case 'Figma':
                                                return <CgFigma key={index} className='iconsTools' title="Figma" />;
                                            case 'Photoshop':
                                            case 'Adobe Photoshop':
                                                return <SiAdobephotoshop key={index} className='iconsTools' title="Adobe Photoshop" />;
                                            case 'Premiere Pro':
                                            case 'PremierePro':
                                            case 'Adobe Premiere Pro':
                                                return <SiAdobepremierepro key={index} className='iconsTools' title="Adobe Premiere Pro" />;
                                            case 'Firebase':
                                            case 'firebase':
                                                return <IoLogoFirebase key={index} className='iconsTools' title="Firebase" />;
                                            case 'VSCODE':
                                            case 'VSCode':
                                            case 'VS Code':
                                            case 'vscode':
                                                return <DiVisualstudio key={index} className='iconsTools' title="Visual Studio Code" />;
                                            case 'REACTJS':
                                            case 'ReactJs':
                                            case 'React':
                                            case 'React Js':
                                            case 'React JS':
                                            case 'reactjs':
                                                return <FaReact key={index} className='iconsTools' title="React Js" />;
                                            case 'InDesign':
                                            case 'Indesign':
                                            case 'indesign':
                                            case 'inDesign':
                                            case 'Adobe Indesign':
                                            case 'Adobe InDesign':
                                                return <SiAdobeindesign key={index} className='iconsTools' title="Adobe InDesign" />;
                                            case 'Excel':
                                            case 'Microsoft Excel':
                                            case 'Microsoft excel':
                                            case 'excel':
                                                return <PiMicrosoftExcelLogoFill key={index} className='iconsTools' title="Adobe InDesign" />;

                                                case 'After Effects':
                                            case 'after effects':
                                            case 'AfterEffects':
                                            case 'After effects':
                                            case 'Adobe After Effects':
                                                return <SiAdobeaftereffects key={index} className='iconsTools' title="Adobe After Effects" />;
                                                

                                            // Add cases for other tools
                                            default:
                                                return <span key={index}>{trimmedTool}</span>; // If no icon is defined, display the tool name as text
                                        }
                                    })}
                                </p>

                                {project?.linkUrl ? (
                                    <div className="buy">
                                        <button>
                                            <a href={project.linkUrl} rel="noreferrer" target="_blank">
                                                View Site
                                            </a>
                                        </button>
                                    </div>
                                ) : null}

                            </Col>

                            <Col >
                                <div className="MainImage">
                                    {project.PhotoUrl && project.Label === 'Video' ? (
                                        currentImageIndex === 0 && (
                                            <video autoPlay loop muted className="projIm">
                                                <source src={project.PhotoUrl} type="video/mp4" />
                                                Your browser does not support the video tag.
                                            </video>
                                        )
                                    ) : (
                                        currentImageIndex === 0 && ( // Display the main image only when the index is 0
                                            <img
                                                src={project.PhotoUrl}
                                                alt={`Project Main`}
                                                key={project.id}
                                                onClick={handleImageClick}
                                                className="projIm"
                                            />
                                        )
                                    )}
                                    {currentImageIndex !== 0 && images.length > 0 && (
                                        // Display the subcollection images or videos when index is not 0
                                        images[currentImageIndex - 1].Label === 'Video' ? (
                                            <video controls className="projIm">
                                                <source src={images[currentImageIndex - 1].Url} type="video/mp4" />
                                                Your browser does not support the video tag.
                                            </video>
                                        ) : (
                                            <img
                                                src={images[currentImageIndex - 1].Url}
                                                alt={`Project ${currentImageIndex}`}
                                                className="projIm"
                                                key={currentImageIndex}
                                                onClick={handleImageClick}
                                            />
                                        )
                                    )}
                                </div>


                            </Col>

                        </Row>
                        <Row>
                            <Col lg={4} className='infomo'>

                                <Col>
                                    <div className="como">
                                        <h4>Duration</h4>
                                        <p>{project.Duration}</p>
                                    </div>

                                </Col>
                                <Col>
                                    <div className="como">
                                        <h4>Time Frame</h4>
                                        <p>{project.Year}</p>
                                    </div>
                                </Col>
                                <Col>
                                    <div className="como">
                                        <h4>Revisions</h4>
                                        <p>{project.Revisions}</p>
                                    </div>
                                </Col>
                            </Col>
                        </Row>


                        <div className='ProjImg'>
                            <h4>Other Images:</h4>
                            <Row>
                                <div className="gridlike">
                                {images.map((image, index) => (
                                    <div  lg={3} key={index} onClick={() => handleImageClick(index)}>

                                        <img src={image.Url} alt={`Project ${index}`} />

                                    </div>
                                ))}
                                </div>
                                

                            </Row>

                        </div>
                    </div>
                )}
                {/* Display other project details as needed */}
            </Container>


            <MeteFooter />
        </div>
    )
}

export default FullProject
